

import ImageSlider from './ImageSlider'; 


import LibraryImage from '../assets/images/facilities/Library.jpg';

const images = [
    { src: LibraryImage, altText: 'Cafeteria' },
   
];
const Library = () => {
  return (

<section className="ftco-section ftco-no-pb">
    <div className="container">
    
    <div className="row justify-content-center  pb-4">
        <div className="col-md-12  heading-section ftco-animate text px-4">
          <h2 className="mb-4 text-success text-center">
          📚 SRN Library & Resources
          </h2>   
        </div>
      </div>
        
    
      <div className="row mt-3">
        <div className=" col-md-8 order-md-first ">
          <div className="text px-4">
             
              <p> 
              The SRN Library & Resources center is a hub of knowledge, learning, and intellectual growth. Designed to inspire curiosity and a love for reading, our library serves as a vital resource for students, teachers, and researchers.  </p>
              <p>
              🌟 Features of SRN Library:<br/>

✅ Vast Collection of Books – A diverse range of books covering academics, literature, history, science, and more.<br/>
✅ Digital Library Access – Online journals, e-books, and research databases for extended learning.<br/>
✅ Reference Section – Encyclopedias, dictionaries, and subject-specific reference materials.<br/>
✅ Reading & Study Areas – A peaceful environment for students to study and engage in research.<br/>
✅ Newspaper & Magazines – Access to the latest news, current affairs, and educational publications.<br/>
✅ Multimedia & E-Learning Resources – Audiobooks, educational videos, and interactive learning tools.<br/>

📖 Library Guidelines:<br/>

📍 Maintain silence for a productive reading atmosphere.<br/>
📍 Books must be returned within the due date to ensure availability for all.<br/>
📍 Digital resources are accessible for registered users.<br/>
📍 Respect library property and handle books with care.<br/>
              </p>
              <p>
The SRN Library & Resources is committed to fostering a reading culture and supporting students in their academic and personal development. Whether you seek knowledge, research materials, or a quiet place to study, our library is here to enrich your learning journey.<br/>

📍 Location: Library Block <br/>
🕒 Timings: 9.00 A.M - 3 P.M<br/>
📞 Contact: Library Staff<br/>

We invite all students to make the most of this valuable resource!


            </p>
            </div>
          </div>
          <div className=" col-md-4 order-md-first wrap-about">
                    <ImageSlider images={images} />              
                    </div>
      
      </div>  
      </div>

        </section>
  );
};

export default Library;
